import { renotifyBackoffSeconds } from "@/lib/boundary/backoff";

export const ISSUE_MESSAGE_MAX_CHARS = 500;
export const ISSUE_STACK_MAX_CHARS = 4_000;

export function issueFingerprint(errorMessage: string, route: string): string {
  const input = `${errorMessage.trim()}\u0000${route.trim()}`;
  let hash = 0x811c9dc5;
  for (let idx = 0; idx < input.length; idx += 1) {
    hash ^= input.charCodeAt(idx);
    hash = Math.imul(hash, 0x01000193);
  }
  return `v1_${(hash >>> 0).toString(16).padStart(8, "0")}`;
}

export function shouldRealert(
  alarmCount: number,
  lastAlarmAt: Date | string | null,
  now: Date,
): boolean {
  if (!lastAlarmAt) return true;
  const last = lastAlarmAt instanceof Date ? lastAlarmAt : new Date(lastAlarmAt);
  const lastMs = last.getTime();
  if (!Number.isFinite(lastMs)) return true;
  const elapsedMs = now.getTime() - lastMs;
  if (elapsedMs < 0) return false;
  return elapsedMs >= renotifyBackoffSeconds(alarmCount) * 1_000;
}

export function truncateIssueMessage(value: string | null | undefined): string | null {
  return truncateOptionalText(value, ISSUE_MESSAGE_MAX_CHARS);
}

export function truncateIssueStack(value: string | null | undefined): string | null {
  return truncateOptionalText(value, ISSUE_STACK_MAX_CHARS);
}

function truncateOptionalText(
  value: string | null | undefined,
  maxChars: number,
): string | null {
  if (value == null) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  return trimmed.length > maxChars ? trimmed.slice(0, maxChars) : trimmed;
}
